import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import EcosystemLayout from "./components/EcosystemLayout";
import ApplicationModeLayout from "./components/ApplicationModeLayout";
import HomeDashboard from "./pages/HomeDashboard";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import SolutionPage from "./pages/SolutionPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import NotificacionesPage from "./pages/NotificacionesPage";
import CentroAyudaPage from "./pages/CentroAyudaPage";
import ManualPage from "./pages/ManualPage";
import ManualTecnicoPage from "./pages/ManualTecnicoPage";
import TutorialesPage from "./pages/TutorialesPage";
import MisPedidosPage from "./pages/MisPedidosPage";
import PagosFacturacionPage from "./pages/PagosFacturacionPage";
import MiInventarioPage from "./pages/MiInventarioPage";
import ConfiguracionGeneralPage from "./pages/ConfiguracionGeneralPage";
import SeguridadPage from "./pages/SeguridadPage";
import CotizacionesPage from "./pages/CotizacionesPage";
import FavoritosPage from "./pages/FavoritosPage";
import MisClientesPage from "./pages/MisClientesPage";
import SoportePage from "./pages/SoportePage";
import { FavoritosProvider } from "./context/FavoritosContext";
import ConexionLayout from "./pages/conexion/ConexionLayout";
import ConexionDashboard from "./pages/conexion/ConexionDashboard";
import ConexionBuscar from "./pages/conexion/ConexionBuscar";
import ConexionPublicar from "./pages/conexion/ConexionPublicar";
import ConexionDetallePublicacion from "./pages/conexion/ConexionDetallePublicacion";
import ConexionMisPublicaciones from "./pages/conexion/ConexionMisPublicaciones";
import ConexionMensajes from "./pages/conexion/ConexionMensajes";
import ConexionPerfil from "./pages/conexion/ConexionPerfil";
import ConexionPerfilPublico from "./pages/conexion/ConexionPerfilPublico";
import ActividadPage from "./pages/ActividadPage";
import MembresiasPage from "./pages/MembresiasPage";
import MiPerfilLayout from "./pages/mi-perfil/MiPerfilLayout";
import PerfilGlobalPage from "./pages/mi-perfil/PerfilGlobalPage";
import PerfilProfesionalPage from "./pages/mi-perfil/PerfilProfesionalPage";
import VerificacionesPage from "./pages/mi-perfil/VerificacionesPage";
import PortafolioPage from "./pages/mi-perfil/PortafolioPage";
import PerfilPublicoPreviewPage from "./pages/mi-perfil/PerfilPublicoPreviewPage";
import AdminPanel from "./pages/AdminPanel";
import AdminUsuariosPage from "./pages/AdminUsuariosPage";
import AdminWebhooksPage from "./pages/AdminWebhooksPage";
import AdminMarketplaceConfig from "./pages/AdminMarketplaceConfig";
import AuthCallback from "./pages/AuthCallback";
import OnboardingRol from "./pages/OnboardingRol";
import PagoExito from "./pages/PagoExito";
import SoftwareAdmin from "./pages/SoftwareAdmin";import MisDescargas from "./pages/MisDescargas";
import CorexPortal from "./pages/software/CorexPortal";
import CorexValorizaciones from "./pages/software/CorexValorizaciones";
import VmDesignCenter from "./pages/software/VmDesignCenter";
import LicenciaCheckout from "./pages/software/LicenciaCheckout";
import VmEstructural from "./pages/software/VmEstructural";
import VmPrecios from "./pages/software/VmPrecios";
import CorexStatusManifest from "./pages/software/CorexStatusManifest";
import AcademiaAdmin from "./pages/AcademiaAdmin";
import MarketplaceAdmin from "./pages/MarketplaceAdmin";
import AdminPromociones from "./pages/AdminPromociones";
const PocExcel = React.lazy(() => import("./pages/poc/PocExcel"));
const CorexExcel = React.lazy(() => import("./pages/software/CorexExcel"));
const CorexExcelWebPoc = React.lazy(() => import("./pages/software/CorexExcelWebPoc"));
const CorexExcelEmbeddedPoc = React.lazy(() => import("./pages/software/CorexExcelEmbeddedPoc"));
const CorexExcelSpreadJsPoc = React.lazy(() => import("./pages/software/CorexExcelSpreadJsPoc"));
const CorexExcelStyleBridgePoc = React.lazy(() => import("./pages/software/CorexExcelStyleBridgePoc"));
import AcademiaCurso from "./pages/AcademiaCurso";
import MisCursos from "./pages/MisCursos";
import MisCertificados from "./pages/MisCertificados";
import MarketplaceLayout from "./pages/marketplace/MarketplaceLayout";
import MiTienda from "./pages/marketplace/MiTienda";
import CrearNegocio from "./pages/marketplace/CrearNegocio";
import CrearTienda from "./pages/marketplace/CrearTienda";
import MisProductos from "./pages/marketplace/MisProductos";
import CrearProducto from "./pages/marketplace/CrearProducto";
import MktMisCursos from "./pages/marketplace/MisCursos";
import MktCrearCurso from "./pages/marketplace/CrearCurso";
import TiendaPublica from "./pages/marketplace/TiendaPublica";
import MarketplacePublic from "./pages/marketplace/MarketplacePublic";
import ProductoDetalle from "./pages/marketplace/ProductoDetalle";
import CursoDetalle from "./pages/marketplace/CursoDetalle";
import TiendaCatalogo from "./pages/marketplace/TiendaCatalogo";
import SeccionPlaceholder from "./pages/marketplace/SeccionPlaceholder";
import PublicMarketplaceLayout from "./pages/marketplace/PublicMarketplaceLayout";
import CarritoPage from "./pages/marketplace/CarritoPage";
import PagoExitoMarketplace from "./pages/marketplace/PagoExitoMarketplace";
import MisComprasPage from "./pages/marketplace/MisComprasPage";
import ComisionesVendedor from "./pages/marketplace/ComisionesVendedor";
import EstadisticasVendedor from "./pages/marketplace/EstadisticasVendedor";
import ConfiguracionVendedor from "./pages/marketplace/ConfiguracionVendedor";
import LegalPage from "./pages/legal/LegalPage";
import VerificarCertificado from "./pages/VerificarCertificado";
import { Toaster } from "sonner";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-brand-blue/20 border-t-brand-blue rounded-full animate-spin" />
        <p className="text-slate-500 font-medium">Cargando ConstruLink ID…</p>
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <LoadingScreen />;
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.needs_onboarding && location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return children;
}

// Ruta exclusiva de administración: valida sesión + rol admin. Sin sesión → login; sin rol → Dashboard.
function AdminRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <LoadingScreen />;
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

// Catálogo público del Marketplace: accesible sin sesión.
// Usuarios autenticados lo ven con el chrome normal del ecosistema (sidebar/topbar);
// visitantes sin sesión lo ven con una barra pública básica.
function MarketplaceCatalogLayout() {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user && user !== false) return <EcosystemLayout />;
  return <PublicMarketplaceLayout />;
}

function InnerRoutes() {
  const location = useLocation();
  // Callback de Google OAuth: procesa el session_id ANTES de cualquier ruta protegida.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <LoginPage />
          </PublicOnly>
        }
      />
      <Route
        path="/register"
        element={
          <PublicOnly>
            <RegisterPage />
          </PublicOnly>
        }
      />
      <Route path="/academia/verificar/:codigo" element={<VerificarCertificado />} />
      {/* Núcleo oficial COREX Excel = interfaz Style Bridge (reutiliza el componente existente, sin duplicar).
          La pantalla antigua (CorexExcel/Workbook API→UniverAdapter/Certificación T01-T22) se retira de la
          experiencia normal. La ruta técnica /corex-excel-stylebridge-poc se mantiene como alias/QA. */}
      <Route
        path="/corex-excel"
        element={
          <AdminRoute>
            <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando COREX Excel…</div>}>
              <CorexExcelStyleBridgePoc />
            </React.Suspense>
          </AdminRoute>
        }
      />
      {/* POC ARQUITECTURA C · COREX marco + Excel para la Web (WOPI) — PARALELA, no toca /corex-excel */}
      <Route
        path="/corex-excel-web-poc"
        element={
          <AdminRoute>
            <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando POC Arquitectura C…</div>}>
              <CorexExcelWebPoc />
            </React.Suspense>
          </AdminRoute>
        }
      />
      {/* STYLE BRIDGE UNIVERSAL · cualquier .xlsx → interpretación OOXML → Univer — PARALELA */}
      <Route
        path="/corex-excel-stylebridge-poc"
        element={
          <AdminRoute>
            <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando Style Bridge…</div>}>
              <CorexExcelStyleBridgePoc />
            </React.Suspense>
          </AdminRoute>
        }
      />
      {/* POC D2 · SpreadJS (alta fidelidad) vs Univer OSS — PARALELA, misma arquitectura COREX */}
      <Route
        path="/corex-excel-spreadjs-poc"
        element={
          <AdminRoute>
            <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando POC D2 (SpreadJS)…</div>}>
              <CorexExcelSpreadJsPoc />
            </React.Suspense>
          </AdminRoute>
        }
      />
      {/* POC ARQUITECTURA D · COREX marco + Spreadsheet embebido REAL (Univer) — PARALELA */}
      <Route
        path="/corex-excel-embedded-poc"
        element={
          <AdminRoute>
            <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando POC Arquitectura D…</div>}>
              <CorexExcelEmbeddedPoc />
            </React.Suspense>
          </AdminRoute>
        }
      />
      {/* POC AISLADA · Excel real + Univer (ruta separada, no toca COREX) */}
      <Route
        path="/poc-excel"
        element={
          <React.Suspense fallback={<div style={{ padding: 40, fontFamily: "system-ui" }}>Cargando POC…</div>}>
            <PocExcel />
          </React.Suspense>
        }
      />
      {/* Páginas legales públicas */}
      <Route path="/legal/terminos" element={<LegalPage tipo="terminos" />} />
      <Route path="/legal/privacidad" element={<LegalPage tipo="privacidad" />} />
      <Route path="/legal/reembolsos" element={<LegalPage tipo="reembolsos" />} />
      {/* Catálogo público del Marketplace (accesible sin sesión) */}
      <Route element={<MarketplaceCatalogLayout />}>
        <Route path="/tienda" element={<MarketplacePublic />} />
        <Route path="/tienda/producto/:id" element={<ProductoDetalle />} />
        <Route path="/tienda/curso/:id" element={<CursoDetalle />} />
        <Route path="/tienda/carrito" element={<CarritoPage />} />
        <Route path="/tienda/pago/exito" element={<PagoExitoMarketplace />} />
        <Route path="/tienda/mis-compras" element={<MisComprasPage />} />
        <Route path="/tienda/t/:storeId" element={<TiendaCatalogo />} />
      </Route>
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <OnboardingRol />
          </ProtectedRoute>
        }
      />
      {/* F1.1 · APPLICATION MODE — programas especializados a pantalla completa */}
      <Route
        element={
          <ProtectedRoute>
            <ApplicationModeLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/software/corex" element={<CorexPortal />} />
        <Route path="/software/corex-valorizaciones" element={<CorexValorizaciones />} />
        <Route path="/software/vivienda-multifamiliar" element={<VmDesignCenter />} />
        <Route path="/software/licencia/:slug" element={<LicenciaCheckout />} />
        <Route path="/software/estructural" element={<VmEstructural />} />
        <Route path="/software/actualizacion-precios" element={<VmPrecios />} />
      </Route>
      <Route
        element={
          <ProtectedRoute>
            <EcosystemLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomeDashboard />} />
        {/* Sistema de Perfiles (Módulo 2) */}
        <Route path="/mi-perfil" element={<MiPerfilLayout />}>
          <Route index element={<Navigate to="/mi-perfil/global" replace />} />
          <Route path="global" element={<PerfilGlobalPage />} />
          <Route path="profesional" element={<PerfilProfesionalPage />} />
          <Route path="portafolio" element={<PortafolioPage />} />
          <Route path="verificaciones" element={<VerificacionesPage />} />
        </Route>
        <Route path="/mi-perfil/publico" element={<PerfilPublicoPreviewPage />} />
        {/* Pilar 01 — Plataforma de Conexión (marketplace) */}
        <Route path="/conexion" element={<ConexionLayout />}>
          <Route index element={<ConexionDashboard />} />
          <Route path="buscar" element={<ConexionBuscar />} />
          <Route path="publicar" element={<ConexionPublicar />} />
          <Route path="publicaciones/:id" element={<ConexionDetallePublicacion />} />
          <Route path="mis-publicaciones" element={<ConexionMisPublicaciones />} />
          <Route path="mensajes" element={<ConexionMensajes />} />
          <Route path="perfil" element={<ConexionPerfil />} />
          <Route path="perfil/:userId" element={<ConexionPerfilPublico />} />
        </Route>
        {/* Otras soluciones (placeholders) */}
        <Route path="/software" element={<SolutionPage solutionId="software" />} />
        <Route path="/software/corex/status" element={<AdminRoute><CorexStatusManifest /></AdminRoute>} />
        <Route path="/software/mis-descargas" element={<MisDescargas />} />
        <Route path="/ia" element={<SolutionPage solutionId="ia" />} />
        <Route path="/academia" element={<SolutionPage solutionId="academia" />} />
        <Route path="/academia/mis-cursos" element={<MisCursos />} />
        <Route path="/academia/mis-certificados" element={<MisCertificados />} />
        <Route path="/academia/curso/:id" element={<AcademiaCurso />} />
        <Route path="/marketplace/crear-negocio" element={<CrearNegocio />} />
        <Route path="/marketplace/crear-tienda" element={<CrearTienda />} />
        <Route path="/marketplace/tienda-publica" element={<TiendaPublica />} />
        <Route path="/marketplace/productos/crear" element={<CrearProducto />} />
        <Route path="/marketplace/cursos/crear" element={<MktCrearCurso />} />
        <Route path="/marketplace" element={<MarketplaceLayout />}>
          <Route index element={<MiTienda />} />
          <Route path="productos" element={<MisProductos />} />
          <Route path="cursos" element={<MktMisCursos />} />
          <Route path="ventas" element={<SeccionPlaceholder testid="mkt-ventas" titulo="Mis Ventas" descripcion="Consulta el historial y el detalle de tus ventas cuando tu tienda esté activa." />} />
          <Route path="comisiones" element={<ComisionesVendedor />} />
          <Route path="estadisticas" element={<EstadisticasVendedor />} />
          <Route path="configuracion" element={<ConfiguracionVendedor />} />
        </Route>
        {/* Sidebar módulos */}
        <Route path="/actividad" element={<ActividadPage />} />
        <Route path="/mensajes" element={<Navigate to="/conexion/mensajes" replace />} />
        <Route path="/notificaciones" element={<NotificacionesPage />} />
        <Route path="/proyectos" element={<MisPedidosPage />} />
        <Route path="/inventario" element={<MiInventarioPage />} />
        <Route path="/cotizaciones" element={<CotizacionesPage />} />
        <Route path="/clientes" element={<MisClientesPage />} />
        <Route path="/proveedores" element={<PlaceholderPage moduleKey="proveedores" />} />
        <Route path="/favoritos" element={<FavoritosPage />} />
        <Route path="/planes" element={<MembresiasPage />} />
        <Route path="/pago/exito" element={<PagoExito />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/usuarios" element={<AdminRoute><AdminUsuariosPage /></AdminRoute>} />
        <Route path="/admin/webhooks" element={<AdminRoute><AdminWebhooksPage /></AdminRoute>} />
        <Route path="/admin/promociones" element={<AdminRoute><AdminPromociones /></AdminRoute>} />
        <Route path="/admin/marketplace/config-comercial" element={<AdminRoute><AdminMarketplaceConfig /></AdminRoute>} />
        <Route path="/admin/software" element={<SoftwareAdmin />} />
        <Route path="/admin/academia" element={<AcademiaAdmin />} />
        <Route path="/admin/marketplace" element={<MarketplaceAdmin />} />
        <Route path="/pagos" element={<PagosFacturacionPage />} />
        <Route path="/configuracion" element={<ConfiguracionGeneralPage />} />
        <Route path="/seguridad" element={<SeguridadPage />} />
        <Route path="/centro-ayuda" element={<CentroAyudaPage />} />
        <Route path="/manual" element={<ManualPage />} />
        <Route path="/ayuda/manual-tecnico" element={<AdminRoute><ManualTecnicoPage /></AdminRoute>} />
        <Route path="/tutoriales" element={<TutorialesPage />} />
        <Route path="/soporte" element={<SoportePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <FavoritosProvider>
          <BrowserRouter>
            <InnerRoutes />
            <Toaster position="top-center" richColors closeButton />
          </BrowserRouter>
        </FavoritosProvider>
      </CartProvider>
    </AuthProvider>
  );
}
